import { defineMessages } from 'react-intl';

export default defineMessages({
  haveYouCanceledOrChangedYourJourneyBeforeLeaving: {
    id: 'fastCover.changesToYourJourneySCTIStep.haveYouCanceledOrChangedYourJourneyBeforeLeaving',
    defaultMessage: 'Have you cancelled or changed your journey before leaving?',
  },
  haveYouChangedYourJourneyAfterLeaving: {
    id: 'fastCover.changesToYourJourneySCTIStep.haveYouChangedYourJourneyAfterLeaving',
    defaultMessage: 'Have you changed your journey after leaving?',
  },
  wereYouDelayedWhileTravelingToASpecialEvent: {
    id: 'fastCover.changesToYourJourneySCTIStep.wereYouDelayedWhileTravelingToASpecialEvent',
    defaultMessage: 'Were you delayed while travelling to a special event?',
  },
  wereYouDelayedWhileTravelingToASpecialEventTooltip: {
    id: 'fastCover.changesToYourJourneySCTIStep.wereYouDelayedWhileTravelingToASpecialEventTooltip',
    defaultMessage: 'A wedding, funeral, conference, concert, show, festival, or sporting event.',
  },
  haveYouReceivedAnyCreditOrRefundFromTheServiceProvider: {
    id: 'fastCover.changesToYourJourneySCTIStep.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider',
    defaultMessage: 'Have you received any credit or refund from the service provider?',
  },
  amountCreditedOrRefunded: {
    id: 'fastCover.changesToYourJourneySCTIStep.amountCreditedOrRefunded',
    defaultMessage: 'Amount credited/refunded',
  },
  didYouCancelOrChangeYourTravelPlansDueToARelevantPerson: {
    id: 'fastCover.changesToYourJourneySCTIStep.didYouCancelOrChangeYourTravelPlansDueToARelevantPerson',
    defaultMessage: 'Did you cancel or change your travel plans due to a relevant person?',
  },
  didYouCancelOrChangeYourTravelPlansDueToARelevantPersonTooltip: {
    id: 'fastCover.changesToYourJourneySCTIStep.didYouCancelOrChangeYourTravelPlansDueToARelevantPersonTooltip',
    defaultMessage: `
        Anyone who isn’t named on your Certificate
        of Insurance and who is one of the following:
        • A member of your immediate family
        • Your travelling companion
        • A person directly related to the primary purpose of your journey
    `,
  },
  didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMember: {
    id: 'fastCover.changesToYourJourneySCTIStep.didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMember',
    defaultMessage: 'Did you cancel or change your travel plans due to an immediate family member?',
  },
  didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMemberTooltip: {
    id: 'fastCover.changesToYourJourneySCTIStep.didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMember',
    defaultMessage: `Anyone who is your:
        • partner
        • fiancé or fiancée
        • parent, stepparent, or parent-in-law
        • grandparent
        • grandchild
        • sibling or sibling-in-law
        • child, stepchild, foster child, or child-in-law
        • niece or nephew.
    `,
  },
  wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition: {
    id: 'fastCover.changesToYourJourneySCTIStep.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition',
    defaultMessage: 'Was the unexpected event related to the relevant person’s existing health condition?',
  },
  wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionTooltip: {
    id: 'fastCover.changesToYourJourneySCTIStep.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionTooltip',
    defaultMessage: `A relevant person’s medical or physical conditions, symptoms, or circumstances that, before the date your insurance starts, they had sought, received, or been recommended:
        • advice
        • care
        • treatment
        • medication
        • medical attention
    `,
  },
  wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthCondition: {
    id: 'fastCover.changesToYourJourneySCTIStep.wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthCondition',
    defaultMessage: 'Was the unexpected event related to the immediate family member’s existing health condition?',
  },
  wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthConditionTooltip: {
    id: 'fastCover.changesToYourJourneySCTIStep.wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthConditionTooltip',
    defaultMessage: `A family member’s medical or physical conditions, symptoms, or circumstances that, before the date your insurance starts, they had sought, received, or been recommended:
        • advice
        • care
        • treatment
        • medication
        • medical attention
    `,
  },
  wereAnyOfYourTravelPlansOrganisedByATravelAgent: {
    id: 'fastCover.changesToYourJourneySCTIStep.wereAnyOfYourTravelPlansOrganisedByATravelAgent',
    defaultMessage: 'Were any of your travel plans organised by a travel agent?',
  },
  wereYouChargedACancellationFeeByTheTravelAgent: {
    id: 'fastCover.changesToYourJourneySCTIStep.wereYouChargedACancellationFeeByTheTravelAgent',
    defaultMessage: 'Have you cancelled or changed your journey before leaving and were charged a cancellation fee by the travel agent?',
  },
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.changesToYourJourneySCTIStep.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  cuttingYourTripShortToReturnHome: {
    id: 'fastCover.changesToYourJourneySCTIStep.cuttingYourTripShortToReturnHome',
    defaultMessage: 'Cutting your trip short to return home',
  },
  travelInterruption: {
    id: 'fastCover.changesToYourJourneySCTIStep.travelInterruption',
    defaultMessage: 'Travel Interruption',
  },
  resumingYourTripBackOverseas: {
    id: 'fastCover.changesToYourJourneySCTIStep.resumingYourTripBackOverseas',
    defaultMessage: 'Resuming your trip back overseas',
  },
  resumptionOfJourneyBackToNZ: {
    id: 'fastCover.changesToYourJourneySCTIStep.resumptionOfJourneyBackToNZ',
    defaultMessage: 'Resumption of journey back to NZ',
  },
  didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption: {
    id: 'fastCover.changesToYourJourneySCTIStep.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption',
    defaultMessage: 'Did you also incur these costs as a result of your travel disruption?',
  },
  petBoardingFacility: {
    id: 'fastCover.changesToYourJourneySCTIStep.petBoardingFacility',
    defaultMessage: 'Pet boarding facility',
  },
  childcareExpenses: {
    id: 'fastCover.changesToYourJourneySCTIStep.childcareExpenses',
    defaultMessage: 'Childcare expenses',
  },
  expenseFor: {
    id: 'fastCover.changesToYourJourneySCTIStep.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfItem: {
    id: 'fastCover.changesToYourJourneySCTIStep.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  descriptionOfExpense: {
    id: 'fastCover.changesToYourJourneySCTIStep.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  dateOfExpenses: {
    id: 'fastCover.changesToYourJourneySCTIStep.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  amountClaimed: {
    id: 'fastCover.changesToYourJourneySCTIStep.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.changesToYourJourneySCTIStep.currency',
    defaultMessage: 'Currency',
  },
  dentalExpenses: {
    id: 'fastCover.changesToYourJourneySCTIStep.dentalExpenses',
    defaultMessage: 'Dental Expenses',
  },
  funeralExpenses: {
    id: 'fastCover.changesToYourJourneySCTIStep.funeralExpenses',
    defaultMessage: 'Funeral Expenses',
  },
  isRequired: {
    id: 'fastCover.changesToYourJourneySCTIStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  addItem: {
    id: 'fastCover.changesToYourJourneySCTIStep.addItem',
    defaultMessage: 'Add Expense',
  },
  itemWithIdx: {
    id: 'fastCover.changesToYourJourneySCTIStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  yes: {
    id: 'fastCover.changesToYourJourneySCTIStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.changesToYourJourneySCTIStep.no',
    defaultMessage: 'No',
  },
  thisSectionRelatesToTravelExpensesSuchAsFlights: {
    id: 'fastCover.changesToYourJourneySCTIStep.thisSectionRelatesToTravelExpensesSuchAsFlights',
    defaultMessage: 'This section relates to travel expenses such as flights, accommodation, tours etc.',
  },
  delayedJourneyToSpecialEvent: {
    id: 'fastCover.changesToYourJourneySCTIStep.delayedJourneyToSpecialEvent',
    defaultMessage: 'Delayed journey to special event',
  },
  existingConditionOfARelevantPerson: {
    id: 'fastCover.changesToYourJourneySCTIStep.existingConditionOfARelevantPerson',
    defaultMessage: 'Existing Condition of a relevant person',
  },
  existingConditionOfAnImmediateFamilyMember: {
    id: 'fastCover.changesToYourJourneySCTIStep.existingConditionOfAnImmediateFamilyMember',
    defaultMessage: 'Existing condition of an immediate family member',
  },
  nameOfRelevantPerson: {
    id: 'fastCover.changesToYourJourneySCTIStep.nameOfRelevantPerson',
    defaultMessage: 'Name of relevant person',
  },
  dateOfBirthOfRelevantPerson: {
    id: 'fastCover.changesToYourJourneySCTIStep.dateOfBirthOfRelevantPerson',
    defaultMessage: 'Date of birth of relevant person',
  },
  relationshipWithRelevantPerson: {
    id: 'fastCover.changesToYourJourneySCTIStep.relationshipWithRelevantPerson',
    defaultMessage: 'Relationship with relevant person',
  },
  cancellingOrChangingYourJourney: {
    id: 'fastCover.changesToYourJourneySCTIStep.cancellingOrChangingYourJourney',
    defaultMessage: 'Cancelling or changing your journey',
  },
  cancellingOrChangingYourJourneyBeforeYouLeave: {
    id: 'fastCover.changesToYourJourneySCTIStep.cancellingOrChangingYourJourneyBeforeYouLeave',
    defaultMessage: 'Cancelling or changing your journey before you leave',
  },
  nameOfImmediateFamilyMember: {
    id: 'fastCover.changesToYourJourneySCTIStep.nameOfImmediateFamilyMember',
    defaultMessage: 'Name of immediate family member',
  },
  dateOfBirthOfImmediateFamilyMember: {
    id: 'fastCover.changesToYourJourneySCTIStep.dateOfBirthOfImmediateFamilyMember',
    defaultMessage: 'Date of birth of immediate family member',
  },
  relationshipWithImmediateFamilyMember: {
    id: 'fastCover.changesToYourJourneySCTIStep.relationshipWithImmediateFamilyMember',
    defaultMessage: 'Relationship with immediate family member',
  },
  selectInsuredForExpense: {
    id: 'fastCover.changesToYourJourneySCTIStep.selectInsuredForExpense',
    defaultMessage: 'Select the Insured(s) for the expense',
  },
  checkEventDate: {
    id: 'fastCover.stepWhatHappened.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  amountClaimExceedsMaximumDigits: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountClaimExceedsMaximumDigits',
    defaultMessage: 'Amount Claimed exceeds the maximum allowable digits. Please enter a valid claim amount.',
  },
  travelAgentCancellationCover: {
    id: 'fastCover.changesToYourJourneySCTIStep.travelAgentCancellationCover',
    defaultMessage: 'Travel Agent Cancellation Cover',
  },
  
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.ChangesToYourJourney/messages.js